import { Api } from 'api';
import { callApi } from 'root/appSaga';
import { all, put, takeEvery } from 'redux-saga/effects';
import * as companyActions from 'features/company/companyActions';
import { Company, FeaturePermission, SagaGenerator, TelematicProviderTypeMetadata } from 'types';


export function* companySaga(): SagaGenerator {
    return yield all([
        takeEvery(companyActions.COMPANY_CREATE_START, createCompany),
        takeEvery(companyActions.COMPANY_UPDATE_START, updateCompanyDetails),
        takeEvery(companyActions.COMPANY_REQUEST_START, getCompanyDetails),
        takeEvery(companyActions.COMPANY_CREATE_COMPLETED, getCompanyDetails),
        takeEvery(companyActions.REQUEST_TELEMATIC_ACCOUNT_TYPES_START, getAllTelematicAccountTypeMetadata),
        takeEvery(companyActions.COMPANY_REQUEST_FEATURE_PERMISSIONS, getCompanyFeaturePermissions)
    ]);
}

export function* createCompany(params: ReturnType<typeof companyActions.createCompany>) {
    try {
        const company = params.payload.company;
        yield callApi(Api.createCompany, company);
        yield put(companyActions.createCompanyCompleted(company));
    } catch (error) {
        yield put(companyActions.createCompanyError(error));
    }
}

export function* getCompanyDetails() {
    try {
        const company: Company = yield callApi(Api.getCompanyDetails);
        yield put(companyActions.getCompanyDetailsCompleted(company));
    } catch (error) {
        yield put(companyActions.getCompanyDetailsError(error));
    }
}

export function* updateCompanyDetails(params: ReturnType<typeof companyActions.updateCompanyDetails>) {
    const { companyDetails, formSource } = params.payload;
    try {
        yield callApi(Api.updateCompanyDetails, companyDetails);
        yield put(companyActions.updateCompanyDetailsCompleted(companyDetails, formSource));
    } catch (error) {
        yield put(companyActions.updateCompanyDetailsError(error, formSource));
    }
}

export function* getAllTelematicAccountTypeMetadata() {
    try {
        const telematicProviderTypeMetadata: TelematicProviderTypeMetadata[] = yield callApi(Api.getAllTelematicAccountTypes);
        yield put(companyActions.getTelematicAccountTypesCompleted(telematicProviderTypeMetadata));
    } catch (error) {
        yield put(companyActions.getTelematicAccountTypesError(error));
    }
}

export function* getCompanyFeaturePermissions() {
    try {
        const featurePermissions: FeaturePermission[] = yield callApi(Api.getCompanyFeaturePermissions);
        yield put(companyActions.getCompanyFeaturePermissionsCompleted(featurePermissions));
    } catch (error) {
        console.error('getCompanyFeaturePermissionsError', error);
        yield put(companyActions.getCompanyFeaturePermissionsError(error));
    }
}
